const Projects = [    
    {
        id: 1,
        image: './../img/arrivo-logo.png',
        projetoLink: 'https://arrivo.co.it/',
        category: 'elementor', 
    }, 
    {
        id: 2,
        image: './../img/logo-ncn.png',
        projetoLink: 'https://advocaciancn.com.br/',
        category: 'elementor', 
    }, 
    {
        id: 3,
        image: './../img/ips-logo.png',
        projetoLink: 'https://ipsclinic.com.br/',
        category: 'elementor', 
    }, 
    {
        id: 4,
        image: './../img/sussurros-logo.png',
        projetoLink: 'https://sussurrosdoinvisivel.com/',
        category: 'elementor', 
    },    
    {
        id: 5,
        image: './../img/logo-delta.png',
        projetoLink: 'https://deltaseguranca.com.br/',
        category: 'elementor', 
    },
    {
        id: 6,
        image: './../img/digitaliano.png',
        projetoLink: 'https://digitaliano.com.br/',
        category: 'elementor', 
    },   
    {
        id: 7,
        image: './../img/logo-maximus.png',
        projetoLink: 'https://maximusengenhariainovacao.com.br/',
        category: 'elementor', 
    },
    {
        id: 8,
        image: './../img/elenex-logo.png',
        projetoLink: 'https://elenex.vercel.app/',
        codigoLink: 'https://github.com/danilogomes08/elenex',
        category: 'reactJS', 
    },
    {
        id: 9,
        image: './../img/danilo-portfolio.png',
        projetoLink: 'https://portfolio-react-seven-beta.vercel.app/',
        codigoLink: 'https://github.com/danilogomes08/portfolio-react',
        category: 'reactJS', 
    },
    {
        id: 10,
        image: './../img/logo-pokemonV2.png',
        projetoLink: 'https://pokedexv2-lake.vercel.app',
        codigoLink: 'https://github.com/danilogomes08/pokedexv2',
        category: 'reactJS', 
    },
    {
        id: 11,
        image: './../img/logo-open.png',
        projetoLink: 'https://danilogomes08.github.io/weather',
        codigoLink: 'https://github.com/danilogomes08/weather',
        category: 'reactJS', 
    },
    {
        id: 12,
        image: './../img/logo-pokemon.png',
        projetoLink: 'https://danilogomes08.github.io/pokedex/',
        codigoLink: 'https://github.com/danilogomes08/pokedex',
        category: 'reactJS', 
    },
    {
        id: 13,
        image: './../img/cn-logo.png',
        projetoLink: 'https://carvalhonascimento.adv.br',
        codigoLink: '',
        category: 'elementor', 
    },
    {
        id: 14,
        image: './../img/logo-katy.png',
        projetoLink: 'https://katylessons.com.br',
        codigoLink: '',
        category: 'elementor', 
    }, 
    {
        id: 15,
        image: './../img/logo-couldbuilder.png',
        projetoLink: 'https://cobuild-tau.vercel.app/',
        codigoLink: 'https://github.com/danilogomes08/cobuild',
        category: 'hcj', 
    },
    {
        id: 16,
        image: './../img/logo-cozy.png',
        projetoLink: 'https://cozy-house-iota.vercel.app/',
        codigoLink: 'https://github.com/danilogomes08/cozy-house',
        category: 'sass', 
    },
    {
        id: 17,
        image: './../img/logo-interact.png',
        projetoLink: 'https://interact-delta.vercel.app/',
        codigoLink: 'https://interact-delta.vercel.app/',
        category: 'bootstrap', 
    },
    {
        id: 18,
        image: './../img/logo-medidove.png',
        projetoLink: 'https://medidove-nine.vercel.app/',
        codigoLink: 'https://github.com/danilogomes08/medidove',
        category: 'hcj', 
    },
    {
        id: 19,
        image: './../img/logo-softwerk.png',
        projetoLink: 'https://softwerk.vercel.app/',
        codigoLink: 'https://github.com/danilogomes08/softwerk',
        category: 'hcj', 
    },
]

export default Projects